import React from 'react';

import { useLocale } from 'next-intl';

import Heading from '@/ui/components/Heading';

const messages = {
  en: {
    one: '{count} comment',
    other: '{count} comments',
  },
  de: {
    one: '{count} Kommentar',
    other: '{count} Kommentare',
  },
  fr: {
    one: '{count} commentaire',
    other: '{count} commentaires',
  },
  es: {
    one: '{count} comentario',
    other: '{count} comentarios',
  },
  it: {
    one: '{count} commento',
    other: '{count} commenti',
  },
  ja: {
    one: '{count} コメント',
    other: '{count} コメント',
  },
  pl: {
    one: '{count} komentarz',
    few: '{count} komentarze',
    many: '{count} komentarzy',
    other: '{count} komentarzy',
  },
  cs: {
    one: '{count} komentář',
    few: '{count} komentáře',
    many: '{count} komentářů',
    other: '{count} komentářů',
  },
};

/**
 * @todo translation
 */
export default function CommentsCount({ count }) {
  const locale = useLocale();
  const pluralRule = new Intl.PluralRules(locale).select(count);

  if (!count) return null;

  return (
    <Heading headingSize="h3" headingComponent="h3">
      {messages[locale][pluralRule].replace('{count}', count)}
    </Heading>
  );
}
